import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=18ae15f1&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae15f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ae15f1')) {
      api.createRecord('18ae15f1', component.options)
    } else {
      api.reload('18ae15f1', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=18ae15f1&scoped=true&", function () {
      api.rerender('18ae15f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/marketingQR/Index.vue"
export default component.exports